import Glide from '@glidejs/glide';

const carousels = document.querySelectorAll('.clients-carousel');

if (carousels) {
	carousels.forEach((carousel, index) => {
		const glideInstance = new Glide(carousel, {
			type: 'carousel',
			startAt: 0,
			perView: 3,
			focusAt: 'center',
			gap: 30,
			autoplay: false,
			peek: {
				before: 0,
				after: 0,
			},
			breakpoints: {
				768: {
					perView: 1,
				},
			},
		});

		// Update counter on move
		glideInstance.on(['mount.after', 'run'], () => {
			const currentSlide = carousel.querySelector('.glide__current');
			if (currentSlide) {
				currentSlide.textContent = glideInstance.index + 1;
			}
		});

		// Add click handlers for arrows - we must use custom solutions here because data attributes causes browser render issues
		const leftArrow = carousel.querySelector('.glide__arrow--left');
		const rightArrow = carousel.querySelector('.glide__arrow--right');

		if (leftArrow) {
			leftArrow.addEventListener('click', (e) => {
				e.preventDefault();

				glideInstance.go('<');
			});
		}

		if (rightArrow) {
			rightArrow.addEventListener('click', (e) => {
				e.preventDefault();

				glideInstance.go('>');
			});
		}

		glideInstance.mount();
	});
}
